const View = require('public_framework/view')
const $ = require('jquery')

const DEFAULT_PROBLEM_SIZE = '20'

export default class Animation extends View {
  get els () {
    return {
      $images: '@sorting_example',
      $try_me: '@try_me'
    }
  }

  get events () {
    return {
      'click @problem_size': 'updateProblemSize',
      'click @reload_all': 'runAll',
      'click @try_me': 'runAll',
      'click @reload_row': 'runRow',
      'click @reload_col': 'runCol',
      'click @sorting_example': 'runExample',
      'click @td': 'runCard',
      'mouseenter @td': 'showCard',
      'mouseleave @td': 'hideCard'
    }
  }

  constructor () {
    super(...arguments)
    this.problemSize = DEFAULT_PROBLEM_SIZE
    this.tryMe = true
  }

  showCard (e) {
    const $td = $(e.currentTarget)
    return $td.find('@hover_card').fadeIn('fast')
  }

  hideCard (e, img) {
    const $card = $(e.currentTarget).find('@hover_card')

    if (img) {
      return $card.fadeOut('fast', () => this._animateImage(img))
    } else {
      return $card.hide()
    }
  }

  runCard (e) {
    const $td = $(e.currentTarget)
    const $img = $td.find('@sorting_example')
    return this.hideCard(e, $img)
  }

  hideTryMe () {
    if (this.tryMe) {
      this.$try_me().fadeOut('fast')
      this.tryMe = false
    }
  }

  updateProblemSize (e) {
    e.preventDefault()

    this.problemSize = $(e.currentTarget).data('size')

    return this.$images().each((i, img) => {
      const $img = $(img)
      const sizePath = $img.data('static')[this.problemSize]
      return $img.attr('src', sizePath)
    })
  }

  runAll (e) {
    e.preventDefault()
    return this._animateImages(this.$images())
  }

  runRow (e) {
    e.preventDefault()

    const $images = $(e.currentTarget).parents('tr').find('@sorting_example')
    return this._animateImages($images)
  }

  runCol (e) {
    e.preventDefault()

    const $target = $(e.currentTarget).parents('th')
    const idx = $target.index() + 1 // because the first column is for th
    const $images = $(this.el).find(`tr td:nth-child(${idx})`).find('@sorting_example')
    return this._animateImages($images)
  }

  runExample (e) {
    return this._animateImage($(e.currentTarget))
  }

  _animateImages ($images) {
    return $images.each((i, img) => {
      return this._animateImage($(img))
    })
  }

  _animateImage ($img) {
    this.hideTryMe()

    const animationSrc = $img.data('animated')[this.problemSize]
    return $img.attr('src', animationSrc)
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/pages/sorting_algorithms/javascripts/views/animation.js